import './icons.css'

export default defineNuxtPlugin((nuxtApp) => {
});
